export default "__VITE_ASSET__IuHfSsn8__"